var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44331 24.0968H17.5544C21.5097 24.0968 24.1661 21.3223 24.1661 17.1939V7.66627C24.1661 3.53789 21.5097 0.763428 17.5556 0.763428H7.44331C3.48914 0.763428 0.832764 3.53789 0.832764 7.66627V17.1939C0.832764 21.3223 3.48914 24.0968 7.44331 24.0968ZM8.41411 11.2635C6.8057 11.2635 5.49878 9.9548 5.49878 8.34682C5.49878 6.73884 6.8057 5.43015 8.41411 5.43015C10.0214 5.43015 11.3295 6.73884 11.3295 8.34682C11.3295 9.9548 10.0214 11.2635 8.41411 11.2635ZM21.6232 15.8531C22.0138 16.8548 21.8109 18.0588 21.3932 19.0509C20.8982 20.2308 19.9502 21.1242 18.7559 21.5143C18.2257 21.6876 17.6696 21.7635 17.1147 21.7635H7.28232C6.30389 21.7635 5.43809 21.5287 4.72832 21.0917C4.28369 20.8172 4.20509 20.1839 4.53475 19.7733C5.08614 19.087 5.63049 18.3983 6.17953 17.7036C7.22601 16.3744 7.93108 15.9892 8.71476 16.3275C9.03269 16.4671 9.3518 16.6766 9.68028 16.8982C10.5555 17.4929 11.7721 18.3105 13.3746 17.4231C14.4713 16.8089 15.1073 15.7553 15.6612 14.8378L15.6705 14.8225C15.7098 14.7581 15.7487 14.6938 15.7874 14.6296L15.7875 14.6295C15.9736 14.3215 16.1573 14.0177 16.365 13.7377C16.6255 13.3873 17.591 12.2917 18.8416 13.0719C19.6382 13.5631 20.3081 14.2277 21.0249 14.9393C21.2982 15.2114 21.493 15.5208 21.6232 15.8531Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.8444fad12b7d79ff71457cd29625bedf.svg";
export { ForwardRef as ReactComponent };